import { Injectable } from '@angular/core';
import { ToastController, ToastOptions } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private activeToast?: HTMLIonToastElement;

  constructor(public toastController: ToastController) {}

  async showToast(toastType: string, message: string, options?: object) {
    type iconMap = {
      [key: string]: string;
    };
    const errorIcons: iconMap = {
      warning: 'warning',
      error: 'alert-circle',
      info: 'information-circle',
      success: 'checkmark-circle',
    };
    console.log(toastType);
    let defaultOption: ToastOptions = {
      message: message ?? 'An unexpected problem occurred. Please try again later.',
      position: 'top',
      duration: toastType === 'error' ? undefined : 2000,
      mode: 'ios',
      icon: errorIcons[toastType],
      cssClass: ['toast-alignment', toastType + '-toast'],
      buttons: [
        {
          icon: 'close-circle-outline',
          side: 'end',
          role: 'cancel',
        },
      ],
    };
    let option: ToastOptions = { ...defaultOption, ...options };

    if (this.activeToast) {
      await this.activeToast.dismiss();
      this.activeToast = undefined;
    }

    const toast = await this.toastController.create(option);
    this.activeToast = toast;

    toast.onDidDismiss().then(() => {
      if (this.activeToast === toast) {
        this.activeToast = undefined;
      }
    });

    await toast.present();
  }
}
